import { NewVM } from '@/core/models/news.model';
import { DocumentsModel } from '../../../../core/models/common.models';
import {
  GlobalDataVM,
  GetGlobalDataSuccessAction,
  GET_GLOBAL_DATA_SUCCESS,
  SET_ENABLED_SPINNER,
  SpinnerSetEnabledAction,
  SET_DOCUMENTS,
  SetDocumentsSuccessAction,
} from './types';

export const onGetGlobalDataSuccess = (payload: GlobalDataVM): GetGlobalDataSuccessAction => ({
  type: GET_GLOBAL_DATA_SUCCESS,
  payload,
});

export const onSetEnabledSpinner = (payload: boolean): SpinnerSetEnabledAction => ({
  type: SET_ENABLED_SPINNER,
  payload,
});

export const onSetDocuments = (payload: NewVM[]): SetDocumentsSuccessAction => ({
  type: SET_DOCUMENTS,
  payload,
});
